import { createContext } from 'react';
import { AddJobCommand, AddProductCommand, Client, FileData} from '../api/models/schema';

interface ClientContextProps {
  client: Client | undefined;
  addJob: (jobCommand: AddJobCommand) => void;
  uploadPanderFile: (panderFile: FileData) => void;
  addProduct: (product: AddProductCommand) => void;
  editProduct: (productId: number,product: AddProductCommand) => void;
  deleteProduct: (productId: number) => void;
}

export const ClientContext = createContext<ClientContextProps>({
  client: undefined,
  addJob: () => {},
  uploadPanderFile: () => {},
  addProduct: () => {},
  editProduct: () => {},
  deleteProduct: () => {},
});